module.exports = __webpack_public_path__ + "static/media/1-2.1e62cc57.jpg";